import { UomModal } from '../../../core/modal/uom-modal';
import { ProductDetailModal } from './product-detail-modal';
import { ProcessModel } from '../../process/model/process.model';
import { itemMaterialPropertyTypes, ProductTypeModel } from '../../product-type/model/product-type.model';
import { CustomParametersDetailsModel } from '../../../shared/custom-param-detail/model/custom-parameters-details-model';
import { PartCodeDetailModel } from '../../part-code/model/part-code-detail-model';
import { DocumentDetailsModel } from '../../bom/models/document-details-model';
import { UomConstModal } from '../../../core/modal/uom-const-modal';
import { ItemDetailMachine } from './ItemDetailMachine';
import { PartyModal } from '../../party/modal/party-modal';
import { ItemDetailsPlainItemConfigurationModel } from './item-details-plain-item-configuration-model';
import { MachineModal } from '../../machine/modal/machine-modal';

export class ProductModal {
  id: number;
  conversionFactor: number;
  description: string;
  name: string;
  physicalProperty: string;
  productCode: string;
  uom: UomModal;
  secondaryUom: UomConstModal;
  secondaryweight: number;
  isWater = false;
  inputProcessList: Array<ProcessModel>;
  outputProcessList: Array<ProcessModel>;
  itemDetails: Array<ProductDetailModal>;
  productType: Array<ProductTypeModel>;
  finishProductList: Array<ProductModal>;
  isSystemGenerated = false;
  itemCodeConfigDetails: PartCodeDetailModel[];
  itemDetailsCustomParam: Array<CustomParametersDetailsModel>;
  documentDetails: Array<DocumentDetailsModel>;
  minQuantity: number;
  itemDetailsMachine: Array<ItemDetailMachine>;
  itemPropertyRels: Array<itemMaterialPropertyTypes>;
  itemPropertyValueRels: Array<itemMaterialPropertyTypes>;
  isPropertyBasedPrice: boolean;
  price: number;
  packSize: number;
  item: any;
  itemProperties: any;
  itemCode: any;
  machine: MachineModal;
  // Label as a Product #DK15102020
  // isLabelProduct = false;
  // label: ProductModal;
  customer: PartyModal;
  packSizeUom: UomModal;
  isPackSizeBasedCalculation: boolean;

  // material property changes #Dk12122020
  plainItemConfiguration: ItemDetailsPlainItemConfigurationModel;
  tapeBobin: ProductModal;

  // Angular Use Only
  uomName: string;
  secondaryUomName: string;
  file: File[];
  customerName: string;
  productTypeStr: string;
  typeList: string;
  soDetailsId: number;
  hsnCode: string;
  gst: number;
  priceStr: any;
  gstStr: any;
  trimmedItemName: string;
  shortDescription: string;
  longDescription: string;
  shortDescription1:string;
}
